import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconClose } from 'components/icons/close.svg';

const alertStyle = {
  backgroundColor: '#2D0023',
  color: 'white',
  padding: '20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.03)',
  width: '350px',
  maxWidth: '100%',
  boxSizing: 'border-box',
  borderRadius: "15px"
};

const buttonStyle = {
  marginLeft: '20px',
  borderRadius: '100px',
  backgroundColor: '#6E0537',
  flexShrink: "0",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "40px",
  width: "40px",
  cursor: 'pointer',
  color: '#FFFFFF',
  border: "none"
};

const AlertTemplate = ({
  message,
  options,
  style,
  close,
}) => {
  return (
    <div style={{ ...alertStyle, ...style }}>
      {options.type === 'info' && <></>}
      {options.type === 'success' && <></>}
      {options.type === 'error' && <>Fehler: </>}
      {message}
      <button onClick={close} style={buttonStyle}>
        <IconClose style={{width: "16px", height: "16px"}}/>
      </button>
    </div>
  );
};

AlertTemplate.propTypes = {
  style: PropTypes.object,
  options: PropTypes.object,
  message: PropTypes.string,
  close: PropTypes.func,
};

export default AlertTemplate;